import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";

export const fetchReferralTrackingAnalytics = createAsyncThunk(
    "referralTracker/fetchAnalytics",
    async (_, { rejectWithValue }) => {
      try {
        const response = await api.get("api/referral/referral-invite-stats");
        return response.data.data;
      } catch (error: any) {
        if (error.response) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  
  export const fetchReferralTrackingData = createAsyncThunk(
    "referralTracker/fetchData",
    async (params: { search?: string; startDate?: string; endDate?: string; page: number; limit: number }, { rejectWithValue }) => {
      try {
        const response = await api.get("api/referral/accounts-invited-users", { params });
        return response.data.data;
      } catch (error: any) {
        if (error.response) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  
  export const downloadReferralTrackerList = createAsyncThunk(
    "referralTracker/downloadList",
    async (params: { search?: string; startDate?: string; endDate?: string }, { rejectWithValue }) => {
      try {
        const response = await api.get("api/referral/referral-invite-xls-download", {
          params,
          responseType: 'blob',
        });
        return response.data;
      } catch (error: any) {
        if (error.response && error.response.data) {
          if (error.response.data instanceof Blob) {
              try {
                  const errorText = await error.response.data.text();
                  const errorJson = JSON.parse(errorText);
                  return rejectWithValue(errorJson);
              } catch (e) {
                  return rejectWithValue({ message: "An error occurred while parsing the error response." });
              }
          }
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  
  export const fetchTopInvitersData = createAsyncThunk(
    "referralTracker/topInvitersData",
    async (params: { page: number; limit: number }, { rejectWithValue }) => {
      try {
        const response = await api.get("api/referral/top-inviters", { params });
        return response.data.data.data;
      } catch (error: any) {
        if (error.response) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  